<p class="mt-4 mb-2">
  Всего: <b>{{count}}</b>
</p>
<div class="row">
  <div [formGroup]="form" class="col-md-6 col-lg-6 col-xl-4">
    <!--<p class="form-group"><strong>Найдено результатов: {{showed_lines}}</strong></p>-->
    <div class="form-group mb-0 mr-3">
      <app-material-input-search formControlName="search"
      [placeholder]="'Поиск'" [withMb0]="true"></app-material-input-search>
    </div>
  </div>
</div>
<div class="material-datatable-wrapper">
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          @for (el of head; track el) {
            <th [ngStyle]="{'width': (el.width) ? el.width : 'auto'}">
              <div [formGroup]="form">
                <div class="row no-gutters align-items-center flex-nowrap" [ngStyle]="{'width': (el.width) ? el.width : 'auto'}">
                  <div class="col table__input">
                    @if (el.input) {
                      <app-material-input
                        [placeholder] = "el.caption"
                        [formControlName] = "el.name"
                        [cssClass]="'mb-0'">
                      </app-material-input>
                    }
                    @if (!el.input && el.name !== 'search_fields') {
                      {{el.caption}}
                    }
                  </div>
                  @if (el.sort) {
                    <div class="col-auto">
                      <a href="javascript:void(0)" (click)="sortChange(el.name)">
                    <i class="icon" [ngClass]="{'icon_new-sort-none': true == !sort[el.name],
                                        'icon_new-sort-down': 'asc' == sort[el.name],
                                        'icon_new-sort-up': 'desc' == sort[el.name]}"></i>
                      </a>
                    </div>
                  }
                </div>
              </div>
            </th>
          }
        </tr>
      </thead>
      <!-- // -->
      <tbody>
        @for (row of rows; track row; let row_index = $index) {
          <tr>
            <td>
              {{row['datetime_created']}}
            </td>
            @if (row['housing_id']) {
              <td>
                {{row['housing_id']}}
              </td>
            }
            @if (!row['housing_id']) {
              <td>
                {{row['complex_id']}}
              </td>
            }
            <td>
              @if (row['complex_id']) {
                <a class="d-block mb-2" href="/housing2/complex/{{row['complex_id']}}"
                  (click)="goBack.newLink('/housing2/complex/' + row['complex_id'], 'complex_caption' + row_index, $event)">
                  {{row['complex_caption']}}
                </a>
              }
            </td>
            <td>
              @if (row['housing_id']) {
                <a class="d-block mb-2" href="/housing2/house/{{row['housing_id']}}"
                  (click)="goBack.newLink('/housing2/house/' + row['housing_id'], 'housing_caption' + row_index, $event)">
                  {{row['housing_caption']}}
                </a>
              }
              @if (!row['housing_id']) {
                <p>&mdash;</p>
              }
            </td>
            <td>
              @if (row['flat_count']) {
                <p>{{row['flat_count']}}</p>
              }
              @if (!row['flat_count']) {
                <p>&mdash;</p>
              }
            </td>
            <td>
              @if (row['import_caption']) {
                <p>{{row['import_caption']}}</p>
              }
              @if (!row['import_caption']) {
                <p>&mdash;</p>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
